// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"b1751ec4","787":"d0237107"}[chunkId] + ".chunk.js";
};